import { ReactNode } from "react";
import { Button, Modal } from "react-bootstrap";

type Props = {
    id: string;
    show: boolean;
    title: string;
    children: ReactNode;
    closeHandler: () => void;
    saveHandler: () => void;
    saveBtnLabel?: string;
    undoBtnLabel?: string;
    saveBtnSize?: "lg" | "sm";
    undoBtnSize?: "lg" | "sm";
    centered?: boolean,
    size?: "lg" | "sm";
}

export default function CustomModal(props: Props) {
    const { saveBtnLabel, undoBtnLabel, undoBtnSize, saveBtnSize, centered, size } = props;
    return (
        <Modal
            id={props.id}
            show={props.show}
            onHide={props.closeHandler}
            backdrop="static"
            keyboard={false}
            size={size}
            centered={centered}
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    {props.children}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" size={undoBtnSize} className="undo-btn" onClick={props.closeHandler.bind([])}>
                    {undoBtnLabel ? undoBtnLabel : "Close"}
                </Button>
                <Button variant="success" size={saveBtnSize} className="send-btn btn btn-primary" onClick={props.saveHandler.bind([])}>
                    {saveBtnLabel ? saveBtnLabel : "Save changes"}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}